import React, { FC } from "react";
import Markdown from 'react-markdown';
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import rehypeExternalLinks from "rehype-external-links";

import { useMultistepFormStore } from "@components/common/MultistepForm";
import { Card, CardContent, Stack, Typography } from "@components/base";

const Info: FC = () => {
  const { activeInfo, setActiveInfo } = useMultistepFormStore();

  const handleClose = (): void => {
    setActiveInfo(null);
  };

  return activeInfo?.description ? (
    <Card>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        p={3}
        pb={0}
      >
        <Typography variant="subtitle1">{activeInfo.title}</Typography>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <CardContent>
        <Markdown rehypePlugins={[[rehypeExternalLinks, { target: '_blank' }]]}>{activeInfo.description}</Markdown>
      </CardContent>
    </Card>
  ) : null;
};

export default Info;
